import React, { useState } from 'react';
import InformationBlockModal from '../../../InformationBlockModal/InformationBlockModal';
import { massActionsText } from '../../../../constants';
import DropdownSelect from '../../../../../../../../../components/dropdownSelect';
import { Alert, Form, Spin } from 'antd';
import FetchError from '../../../FetchError/FetchError';
import BaseModal from '../../../BaseModal/BaseModal';
import { getOptionsSelect } from '../../../../utils/getOptionsSelect';
import { useSetModalVisible } from '../../../../model/modelState';
import { useSaleQuery } from '../../../../../../../hooks/useSaleAddressQuery';
import useSubmit from '../../../../api/useSubmit';
import { getRenderControl } from '../../../../../../../../../components/SingleControlCustom/getRenderControl';

const { Item: FormItem, create: createForm } = Form;

const FormContainer = ({ form, flats }) => {
  const { validateFields, getFieldValue, resetFields, getFieldDecorator } =
    form;

  const [isConfirmMode, setConfirmMode] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const { data, isFetching, refetch } = useSaleQuery({
    staleTime: Infinity,
    select: (data) => data?.salesAddressLifeCycle,
  });

  const { submitAsync, loading: isLoadingChange } = useSubmit({
    url: '/FlatsGrid/change_sale_address_life_cycle',
    errMsg:
      'Произошла ошибка при изменении значения "Продажа" жизненного цикла помещения',
  });

  const setModalVisible = useSetModalVisible();

  const isError = data?.length === 0;

  const disabledModal = isFetching || isLoadingChange;
  const disabledSelect = isError || isFetching || isLoadingChange;

  const saleValue = getFieldValue('sale');

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFields((err) => {
      if (!err) {
        setConfirmMode(true);
      }
    });
  };

  const handleConfirmSubmit = async (e) => {
    e.preventDefault();

    setErrorMsg(null);

    try {
      const sale = getFieldValue('sale');

      await submitAsync({
        flats,
        massActionsTextError: '"Продажа"',
        body: flats?.map((flat) => ({
          saleAddressLifeCycleId: sale,
          addressId: flat.addressId,
        })),
      });

      setModalVisible(false);
      setConfirmMode(false);
      resetFields();
    } catch (error) {
      setErrorMsg(error.message);
    }
  };

  const cancelSubmit = () => {
    setConfirmMode(false);
    resetFields();
  };

  return (
    <BaseModal
      onCancel={cancelSubmit}
      title={isConfirmMode ? 'Подтвердите изменения' : 'Продажа'}
      okText={isConfirmMode ? 'Сохранить' : 'Продолжить'}
      disabled={disabledModal}
      loading={isLoadingChange}
      onOk={isConfirmMode ? handleConfirmSubmit : handleSubmit}
    >
      {errorMsg && (
        <Alert
          title={errorMsg}
          type="error"
        />
      )}
      <Spin spinning={Boolean(isFetching)}>
        {isError ? (
          <FetchError onClick={() => refetch()} />
        ) : (
          <>
            <Form style={{ display: isConfirmMode ? 'none' : 'block' }}>
              <FormItem>
                {getFieldDecorator('sale', {
                  rules: [
                    {
                      required: true,
                      message: 'Пожалуйста, выберите значение',
                    },
                  ],
                })(
                  <DropdownSelect
                    options={getOptionsSelect(data)}
                    multiple={false}
                    disabled={disabledSelect}
                    loading={isFetching}
                    renderControl={getRenderControl({
                      options: getOptionsSelect(data),
                      value: saleValue,
                      disabled: disabledSelect,
                    })}
                  />
                )}
              </FormItem>
            </Form>

            <div style={{ display: isConfirmMode ? 'block' : 'none' }}>
              <InformationBlockModal
                typeMassActions={massActionsText.sale}
                count={flats.length}
              />
            </div>
          </>
        )}
      </Spin>
    </BaseModal>
  );
};

const ChangeSale = createForm({ name: 'mass_actions_sale' })(FormContainer);

export default ChangeSale;
